import React from 'react';
import Translator from '../../../../core/i18n';
import { Redirect } from 'react-router-dom';
import Input from '../../../../components/input/text/input-formik';
import { Formik, FormikActions } from 'formik';
import { Table } from 'reactstrap';
import Paginate from '../../../../components/table/paginate';
import { IGlobalizationListData, ITranslationPageProps } from '../../../../models/pages/translation';
import moment from 'moment';
import { SelectNoneAsync } from '../../../../components/input/select/main';
import { Confirm, Notification } from '../../../../components/notification/main';
import ApiClient from '../../../../api/alms-api';
import BaseModal from '../../../../modal/base-modal/main';
import TranslationModal from './process-modal';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { IAction, IAppState } from '../../../../models/action/core';
import * as Actions from '../../../../store/actions/translations';
import Loading from '../../../../components/loading/loading';
import ContentLoader from 'react-content-loader';

const T = Translator.create();
let _apiClient: ApiClient;

class CMainTranslationPage extends React.Component<ITranslationPageProps, any> {
    constructor(props: any) {
        super(props);
        _apiClient = new ApiClient();

        this.state = {
            goToHomePage: false,
            isModalOpen: false,
            selectedItem: {},
            newText: "",
            filters: {
                page: 1,
                take: 10,
                total: 0,
                skip: 0,
                query: "",
                orderBy: "-",
            },
            isCustomized: false,
            searchedText: "",
            culture: this.props.culture,
        };
    }

    componentDidMount() {
        this.getGlobalizationList();
    }

    getGlobalizationList = () => {
        const { searchedText, isCustomized, filters, culture } = this.state;
        const { dispatch } = this.props;
        dispatch(Actions.GetGlobalizationList(searchedText, isCustomized, culture, filters.take, filters.skip, filters.page, () => { }, 'getGlobalization', 'get'));
    }

    handleSubmit = (values: any, formikActions: FormikActions<any>) => {
        const { searchedText, isCustomized } = this.state;

        if (Object.keys(values).length === 0) return;

        if (searchedText !== values.searchedText || isCustomized !== values.isCustomized) {
            this.setState({
                searchedText: values.searchedText,
                isCustomized: values.isCustomized
            }, this.getGlobalizationList);
        }
    };

    handlePageChange = (page: number) => {
        this.setState((prevState: any) => ({
            filters: {
                ...prevState.filters,
                page: page,
            },
        }), this.getGlobalizationList);
    };

    handleSelectConditionChange = (selectValue: any) => {
        this.setState({ culture: selectValue }, this.getGlobalizationList);
    }

    handleClearCache = () => {
        _apiClient.RequestAsync('POST', 'api/system/clearcache')
            .then(responseData => {
                if (responseData && responseData.status === 200) {
                    this.getGlobalizationList();
                    Notification.setNotification('success', T.t('r_clear_cache_success_message'), 'topRight');
                }
            })
            .catch(() => {
                Notification.setNotification('error', T.t('r_clear_cache_error_message'), 'topRight');
            });
    }

    handleSelectItem = (item: any, type: string) => {
        this.setState({ selectedItem: item }, () => {
            if (type === "update") {
                this.toggleModal();
            } else {
                this.confirmGlobalizationDelete(item);
            }
        });
    }

    toggleModal = () => {
        this.setState((prevState: any) => ({ isModalOpen: !prevState.isModalOpen }));
    };

    handleTextChange = (e: any) => {
        this.setState({ newText: e });
    }

    handleTextSave = () => {
        const { selectedItem, newText } = this.state;
        const { dispatch } = this.props;
        dispatch(Actions.UpdateGlobalization(selectedItem.globalizationId, selectedItem.globalizationKey, newText, selectedItem.culture, () => { }));
        this.toggleModal();
    };

    confirmGlobalizationDelete = (item: any) => {
        Confirm.setConfirm(
            'normal',
            this.handleGlobalizationDelete,
            "Seçilen yerleştirme anahtarını silmek istediğinize emin misiniz?",
            "r_account_password"
        );
    }

    handleGlobalizationDelete = () => {
        const { selectedItem } = this.state;
        const { dispatch } = this.props;
        dispatch(Actions.DeleteGlobalization(selectedItem.globalizationId, selectedItem.globalizationKey, selectedItem.culture, this.getGlobalizationList));
    }

    render() {
        if (this.state.goToHomePage) {
            return <Redirect push={true} to={window.appSettings.DEFAULT_URL + '/u/Home/Cockpit/'} />;
        }

        const { results, filters } = this.props.translationList;
        const loadingSpaces = 64;

        return (
            <div className='container'>
                <div className="student-course activities-dashboard" style={{ padding: '10px 50px' }}>
                    <div className="row student-course-header question-filter" style={{ paddingTop: 0, paddingBottom: 10 }}>
                        <div className="col-md-6">
                            <div className="d-flex justify-content-between">
                                <h2 style={{ color: '#323231', fontSize: '20px' }}>{T.t('r_gen_application_texts')}</h2>
                            </div>
                        </div>
                        <div className="col-md-6 text-md-right">
                            <a onClick={() => this.setState({ goToHomePage: true })} style={{ fontSize: "12px" }}>
                                {T.t('r_gen_admin_panel_back')}
                                <i className="material-icons ml-2 align-middle" style={{ fontSize: "17px" }}>arrow_forward</i>
                            </a>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-12">
                            <div className="filter-fields mt-4">
                                <Formik initialValues={this.state.filterInitialValues} onSubmit={this.handleSubmit}>
                                    {formik => (
                                        <form onSubmit={formik.handleSubmit}>
                                            <div className="row mt-1 align-items-baseline pl-1 pr-3">
                                                <div className="col-md-4 col-12">
                                                    <div className="form-input form-group date-picker mb-3">
                                                        <Input
                                                            type={'text'}
                                                            name={'searchedText'}
                                                            label={T.t('r_gen_search')}
                                                            formik={formik}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-md-4 col-12">
                                                    <div style={{ zIndex: 2 }} className="tick-radio position-relative">
                                                        <input
                                                            type="checkbox"
                                                            name="isCustomized"
                                                            onChange={() => formik.setFieldValue('isCustomized', !formik.values.isCustomized)}
                                                            id="activity-one"
                                                            className="form-radio"
                                                            checked={formik.values.isCustomized}
                                                        />
                                                        <label htmlFor="activity-one">{T.t('r_customized_words')}</label>
                                                    </div>
                                                </div>
                                                <div className="col-12">
                                                    <div className="text-right my-2">
                                                        <button className="ml-2 category-tag-square tag-green">
                                                            {T.t('r_gen_search')} <i className="material-icons ml-2">search</i>
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </form>
                                    )}
                                </Formik>
                            </div>
                        </div>
                    </div>

                    <div className='row'>
                        <div className='col-12'>
                            <div className='translation-info-message'>
                                <i className="material-icons mr-2">info</i>
                                <div style={{ fontSize: "smaller" }}>
                                    <span>{T.t('r_cache_clear_message_part1')}</span>
                                    <span style={{ fontWeight: "bold" }}>{T.t('r_cache_clear_message_bold')}</span>
                                    <span>{T.t('r_cache_clear_message_part2')}</span>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-12">
                            <div className='d-flex justify-content-between align-items-center mt-3'>
                                <div className="form-input form-group date-picker mb-3" style={{ width: 300 }}>
                                    <SelectNoneAsync
                                        name={'fileUploadTypes'}
                                        setOptions={[
                                            { value: "tr-TR", label: "Türkçe" },
                                            { value: "en-US", label: "English" },
                                            { value: "ar-SA", label: "عربي" }
                                        ]}
                                        setSelectValue={[this.props.culture]}
                                        onChange={(e: any) => this.handleSelectConditionChange(e.value)}
                                        placeHolder={"Dil Seçimi"}
                                        isMulti={false}
                                        isClearable={true}
                                    />
                                </div>
                                <div>
                                    <button onClick={this.handleClearCache} className="category-tag-square tag-green mx-1">
                                        <i className="material-icons mr-2">restart_alt</i>
                                        {T.t('r_clear_cache')}
                                    </button>
                                </div>
                            </div>
                            <div className="page-table helpDesk-table p-0 mt-0" id="getGlobalization_Content">
                                <Table className="table-user-list table-striped table-ellipsis table-mobile table-clickable" striped hover borderless>
                                    <thead>
                                        <tr className='text-center' style={{ backgroundColor: '#eaeaea' }}>
                                            <th>{T.t('r_globalization_localization_key')}</th>
                                            <th>{T.t('r_globalization_text')}</th>
                                            <th>{T.t('r_globalization_last_modified_date')}</th>
                                            <th>{T.t('r_globalization_language')}</th>
                                            <th>{T.t('r_globalization_actions')}</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {results.map((item: IGlobalizationListData, index: number) => {
                                            return (
                                                <tr key={index} className='text-center'>
                                                    <td><span className='text-truncate d-block'>{item.globalizationKey}</span></td>
                                                    <td><span className='text-truncate d-block'>{item.globalizationValue}</span></td>
                                                    <td>{item.updatedDate ? moment(item.updatedDate).format("DD.MM.YYYY HH:mm") : T.t('r_globalization_not_yet_modified')}</td>
                                                    <td><span className='text-truncate d-block'>{item.culture}</span></td>
                                                    <td>
                                                        <button
                                                            style={{ padding: 2 }}
                                                            onClick={() => this.handleSelectItem(item, "update")}
                                                            className="category-tag-square tag-green mx-3"
                                                        >
                                                            <i className="material-icons">edit_document</i>
                                                        </button>
                                                    </td>
                                                </tr>
                                            )
                                        })}
                                    </tbody>
                                </Table>

                                <div className="row-options justify-content-end">
                                    <div className="page-sorting d-flex align-items-center justify-content-center" style={{ marginTop: '5px' }} />
                                    <Paginate class={'custom-paginate'} filters={filters} onPageChange={this.handlePageChange} />
                                </div>
                            </div>
                            <Loading spinnerId={'getGlobalization'} width={'100%'}>
                                <div style={{ backgroundColor: '#eeede9' }}>
                                    <ContentLoader
                                        speed={2}
                                        backgroundColor="#f3f3f3"
                                        foregroundColor="#ecebeb"
                                        viewBox="0 0 700 400"
                                        style={{ width: '100%' }}
                                    >
                                        <rect x="66" y="60" rx="5" ry="5" width="600" height="20" />
                                        <rect x="66" y={loadingSpaces + 56} rx="5" ry="5" width="600" height="20" />
                                        <rect x="66" y={loadingSpaces + 116} rx="5" ry="5" width="600" height="20" />
                                        <rect x="66" y={loadingSpaces + 176} rx="5" ry="5" width="600" height="20" />
                                        <rect x="66" y={loadingSpaces + 236} rx="5" ry="5" width="600" height="20" />
                                    </ContentLoader>
                                </div>
                            </Loading>
                        </div>
                    </div>
                </div>
                <BaseModal
                    minWidth={650}
                    modalIsOpen={this.state.isModalOpen}
                    onClose={this.toggleModal}
                    headerState={T.t('r_grade_all_assignments_modal_header')}
                    headerIcon={'clock'}
                    modalFooter={() => (
                        <div className="modal-footer d-flex justify-content-end">
                            <button type="button" disabled={this.state.newText === ""} onClick={this.handleTextSave} className="btn btn-green">{T.t('r_save_button')}</button>
                        </div>
                    )}
                >
                    <TranslationModal selectedItem={this.state.selectedItem} onChangeText={this.handleTextChange} />
                </BaseModal>
            </div>
        );
    }
}

const mapStateToProps = (state: IAppState, ownProps: ITranslationPageProps): ITranslationPageProps => {
    if (!state) return ownProps;
    return {
        ...ownProps,
        culture: state.login.identitiy.culture,
        translationList: state.translation.translationList
    };
};

const mapDispatchToProps = (dispatch: Dispatch<IAction>) => ({ dispatch });



const TranslationPage = connect(
    mapStateToProps,
    mapDispatchToProps,
)(CMainTranslationPage);

export default TranslationPage;

